import { render, staticRenderFns } from "./SettingWalletDeposit.vue?vue&type=template&id=36819792"
import script from "./SettingWalletDeposit.vue?vue&type=script&lang=js"
export * from "./SettingWalletDeposit.vue?vue&type=script&lang=js"
import style0 from "./SettingWalletDeposit.vue?vue&type=style&index=0&id=36819792&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports